import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, first, switchMap } from "rxjs/operators";
import { Router } from "@angular/router";
import { ToasterService } from "./root-services/toaster.service";
import { environment } from "../environments/environment";
import { NbTokenService } from "@nebular/auth";

@Injectable()
export class BearerInterceptor implements HttpInterceptor {
  constructor(
    private toasterService: ToasterService,
    private tokenService: NbTokenService,
    private router: Router
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!req.url.startsWith(environment.apiUrl)) {
      return next.handle(req);
    }

    return this.tokenService.get().pipe(
      first(),
      switchMap((token) => {
        const tokenValue = token?.isValid() ? token.getValue() : null;
        const cloned = tokenValue
          ? req.clone({
              setHeaders: {
                Authorization: `Bearer ${tokenValue}`,
              },
            })
          : req;

        return next.handle(cloned).pipe(
          catchError((obj: HttpErrorResponse) => {
            if (obj.status === 401) {
              this.tokenService.clear().subscribe(() => {
                this.router.navigate(["/auth/login"]);
              });
              return throwError(() => obj);
            }

            let errorMessage = "حدث خطأ غير متوقع";
            if (typeof obj.error?.message === "string") {
              errorMessage = obj.error.message;
            } else if (obj.error?.message) {
              errorMessage = JSON.stringify(obj.error.message);
            } else if (obj.message) {
              errorMessage = obj.message;
            }

            if (!req.url.includes('/auth/login')) {
              this.toasterService.showToast("danger", "حدث مشكلة ما", errorMessage);
            }
            return throwError(() => obj);
          })
        );
      })
    );
  }
}
